jQuery("#nav-top").slide({
  mainCell: ".nav-imgs",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 8,
  vis: 2,
});
new Swiper("#swiper-btn", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
    delay: 4000,
  },
  loop: true,
});
new Swiper("#sp-swiper1", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
    delay: 4000,
  },
  loop: true,
  slidesPerView: "auto",
  centeredSlides: true,
});

let swiper = new Swiper("#sp-swiper", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },

  loop: true,
  pagination: {
    el: ".pagination1",
    type: "bullets",
    clickable: true,
  },
});

let prods = window.product
function getCur(){
  let color = $('#sp-color div.active').attr('data-val')
  let size = $('#sp-size div.active').attr('data-val')
  return prods.find(item=> item.option1 == color && item.option2 == size)
}
function changePrice(){
  let num = $('#calcNumber').val()
  let price = (getCur().price * num / 100).toFixed(2)
  let compare = (getCur().compare_at_price * num / 100).toFixed(2)
  // if(num == 1){
  //   price = (getCur().price * num / 100).toFixed(2)
  // }else if(num == 2){
  //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
  // }else if(num == 3){
  //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
  // }else {
  //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
  // }
  // price = (price + '').replace('.', ',')
  // compare = (compare + '').replace('.', ',')
  $('#sp_price1').html(price)
  $('#sp_price2').html(compare)
  // let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
  // $(".product-part .brand .num").html(off_font);
}
$('.buyNow').click(function(){
  let num = $('#calcNumber').val()
  window.location.href = '/cart/' + getCur().id + ':' + num
})

$(".reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
    changePrice()
  }
});
$(".add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
  changePrice()
});

let spImgList1 = [
  "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/20240617-b1.png",
  "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/20240617-b2.png",
  "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/20240617-b3.png",
  "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/20240617-b4.png",
];

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList1);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") +
            -215 * $("div#root").css("zoom"),
          // behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();

let spImgLists = [
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-1.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-2.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-2.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-1.png",
    ],
    text: "#01 Blanco",
    color: "rgb(18, 18, 18, 0.5)",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-2.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-3.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-3.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-2.png",
    ],
    text: "#02 Naranja",
    color: "#f3701f",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-3.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-4.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-4.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-3.png",
    ],
    text: "#03 Verde Menta",
    color: "#8ff1cb",
  },
  {
    img: [
 "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-4.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-5.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-5.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-4.png",
    ],
    text: "#04 Azul",
    color: "#6caac3",
  },

  {
    img: [
"https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-5.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-6.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-6.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-5.png",
    ],
    text: "#05 Negro ",
    color: "#1c1c1d",
  },
  {
    img: [
     "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-6.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-7.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-7.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-6.png",
    ],
    text: "#06 Rojo",
    color: "#8c0306",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-7.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-8.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-8.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-7.png",
    ],
    text: "#07 Azul Gris ",
    color: "#465b68",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-8.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-9.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-9.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-8.png",
    ],
    text: "#08 Verde Oscuro",
    color: "#076749",
  },
    {
    img: [
     "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-9.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-10.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-10.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-9.png",
    ],
    text: "#09 Azul Oscuro",
    color: "#005ca8",
  },
  {
    img: [
     "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-10.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-11.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-11.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-10.png",
    ],
    text: "#10 Verde Claro",
    color: "#5c8a6f",
  },
  {
    img: [
     "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-11.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-12.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-12.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-11.png",
    ],
    text: "#11 Verde Medio",
    color: "#008244",
  },

 {
    img: [
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-12.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-13.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-13.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-12.png",
    ],
    text: "#12 Amarillo",
    color: "#ffd17c",
  },

  
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-13.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-14.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-14.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-13.png",
    ],
    text: "#13 Rosa",
    color: "#f6bfd0",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-14.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-15.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-15.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-14.png",
    ],
    text: "#14 Gris Claro",
    color: "#c7c9ca",
  },
  {
    img: [
    "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-15.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-16.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-16.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-15.png",
    ],
    text: "#15 Azul Claro",
    color: "#a4dffb",
  },
  {
    img: [
     "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-16.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-17.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-17.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-16.png",
    ],
    text: "#16 Marrón Oscuro",
    color: "#2d0a02",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-17.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-18.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-18.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-17.png",
    ],
    text: "#17 Naranja Brillante",
    color: "#f7941d",
  },
  {
    img: [
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-18.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-19.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-19.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-18.png",
    ],
    text: "#18 Azul Cielo",
    color: "#40bfef",
  },
  {
    img: [
  "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-19.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-20.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-20.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-19.png",
    ],
    text: "#19 Marrón Rojizo",
    color: "#7b2800",
  },
  {
    img: [
     "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-20.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-21.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-21.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-20.png",
    ],
    text: "#20 Blanco Leche",
    color: "rgb(18, 18, 18, 0.5)",
  },
 
    {
    img: [
    "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-21.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-22.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-22.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-21.png",
    ],
    text: "#21 Amarillo Brillante",
    color: "#f8db33",
  },
  {
    img: [
     "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-02-22.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-21-23.png",
      "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-p-03-23.png",
         "https://cdn.shopify.com/s/files/1/0723/7746/7154/files/2024088-22.png",
    ],
    text: "#22 Gris",
    color: "#585a5e",
  },
];
$(".option").click(function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");
  // style选项
  let colorOptions = $("#sp-color .option.active").index();
  let sizeOptions = $("#sp-size .option.active").index();
    let ml = $("#sp-size .option.active").attr("data-ml");
  $("#text-ml").text(ml)
  if(ml == '600ml') {
    $("#text-ml").css('right','60px')
  } else if (ml == '900ml'){
     $("#text-ml").css('right','102px')
  }else if (ml == '1500ml'){
     $("#text-ml").css('right','192px')
  }else if (ml == '300ml'){
     $("#text-ml").css('right','95px')
  }

  let img0 = $(".p-img");
  img0[0].src = spImgLists[colorOptions].img[sizeOptions];
  $(".sp-brand").html(spImgLists[colorOptions].text);
  $("#sp-color .option").css("borderColor", "#fff");
  $("#sp-color .option.active").css(
    "borderColor",
    spImgLists[colorOptions].color
  );
  changePrice()
});
// 购物车加购动效
$(".cart-btn").click(function () {
  $(this).children("img").addClass("on");
  $(".sp-header-top .sp-cart .num").show();
  setTimeout(function () {
    $(".cart-btn").children("img").removeClass("on");
  }, 500);
  $(".sp-header-top .sp-cart").addClass("on");
  setTimeout(function () {
    $(".sp-header-top .sp-cart").removeClass("on");
  }, 500);
});


$(".product-part .cart-btn").click(function () {
  var data = {
    id: getCur().id,
    quantity: $('#calcNumber').val(),
  };
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    success: function () {
      $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
        $("#cardNum").html(result.item_count);
      });
    },
    dataType: "json",
  });

  var img = $(".product-part .p-img");
  var flyer = img[0].cloneNode(true);
  flyer.classList.add("sp-clone");

  $("#shopping").append(flyer);
  $(".sp-clone").css({
    width: img[0].width,
    height: img[0].height,
    position: "fixed",
    top: img[0].offsetTop,
    left: img.offset().left,
    "z-index": "99",
  });

  let finish = $(".sp-cart");
  $(".sp-clone").animate(
    {
      top: finish[0].offsetTop + $(".sp-nav-top").height(),
      left: finish[0].offsetLeft + finish.width() / 2,
      width: 50, // 结束时的大小，根据需要调整
      height: 50, // 结束时的大小，根据需要调整
      opacity: 0.4,
    },
    500,
    "linear",
    function () {
      $(this).animate(
        {
          width: 0,
          height: 0,
          opacity: 0,
        },
        0
      );
    }
  );
});
